function shouldMirrorLocalHostname(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function normalizeApiBaseUrl(value) {
  const base = String(value || 'http://localhost:3000').replace(/\/+$/, '');
  if (base.endsWith('/api/v1')) {
    return base;
  }
  return `${base}/api/v1`;
}

export function resolveApiBaseUrl(value, currentHostname) {
  const normalized = normalizeApiBaseUrl(value);
  const hostname = String(currentHostname || '').trim();

  if (!hostname) {
    return normalized;
  }

  const url = new URL(normalized);
  if (shouldMirrorLocalHostname(url.hostname) && shouldMirrorLocalHostname(hostname)) {
    url.hostname = hostname;
  }

  return url.toString().replace(/\/+$/, '');
}
